import { clientRequestInitator } from '@ebay/nuts-js-client/src/client';

export default class {
    onCreate(input) {
        const { sellerId } = input;
        this.state = {
            sellerId
        };
    }
    onMount() {
        this.callDeli();
    }
    callDeli() {
        clientRequestInitator({
            endPoint: '/str/demand',
            placements: [101497],
            context: {
                ext: {
                    slr: this.state.sellerId
                }
            },
            constraints: {
                modules: [
                    'HTML_MODULE',
                    'CACHE_MODULE'
                ]
            }
        });
    }
}
